<template>
  <div>
    <div :style="style" class="relative">
      <button
        ref="button"
        class="block w-full h-10 p-2 pr-8 text-left placeholder-gray-400 bg-no-repeat border border-gray-300 rounded appearance-none dropdown-bg-color"
        :class="{ 'bg-gray-50': disabled }"
        type="button"
        @[isClick]="toggle"
      >
        <span v-if="value !== null">{{ value.name }}</span>
        <span v-else>{{ placeholder }}</span>
      </button>

      <div
        v-show="isOpen"
        class="absolute left-0 right-0 bottom-auto mt-1 overflow-auto dropdown-bg-color border rounded shadow max-h-dropdown z-10"
      >
        <div
          v-if="filteredOptions.length > 3 || search !== ''"
          class="sticky top-0 p-2 border-b dropdown-bg-color"
        >
          <input
            ref="search"
            type="text"
            class="block w-full h-10 p-2 placeholder-gray-400 border border-gray-300 rounded appearance-none dropdown-bg-color"
            v-model="search"
            @keydown.esc="close"
            role="searchbox"
            aria-label="Search options"
          />
        </div>
        <ul v-show="filteredOptions.length > 0">
          <li v-for="(option, index) in filteredOptions" :key="index">
            <span
              class="block p-2 text-sm cursor-pointer hover:selected-item"
              :class="{ 'selected-item': value == option }"
              @click="select(option)"
              >{{ option.name }}</span
            >
          </li>
        </ul>
        <div
          class="p-2 text-sm"
          v-if="options.length > 0 && filteredOptions.length === 0"
        >
          No results found for "{{ search }}"
        </div>
        <div class="p-2 text-sm" v-if="options.length === 0">
          No available options
        </div>
      </div>
      <span
        v-if="otherCarrierNote"
        class="relative block leading-relaxed mt-1 rounded text-xs opacity-75"
      >
        {{ otherCarrierNote }}
      </span>
      <span
        v-if="value && value.notes && !isMint"
        class="relative block leading-relaxed mt-1 rounded text-xs opacity-75"
      >
        {{ value.notes }}
      </span>
      <template v-if="value && value.notes && isMint">
        <span
          v-if="isMintLocation"
          class="relative block leading-relaxed mt-1 rounded font-bold text-red-400"
        >
          {{ value.notes }}
        </span>
        <span
          v-if="!isMintLocation && !['Aetna', 'Other'].includes(value.name)"
          class="relative block leading-relaxed mt-1 rounded text-xs opacity-75"
        >
          {{ value.notes }}
        </span>
        <!-- <span
          v-if="isMintLocation"
          class="relative block leading-relaxed mt-1 rounded text-xs opacity-75"
        >
          {{ value.notes }}
        </span> -->
        <!-- <span
          v-if="isMintLocation"
          class="relative block leading-relaxed mt-1 rounded font-bold text-red-400"
        >
          {{ value.notes }}
        </span> -->
      </template>
    </div>
  </div>
</template>

<script>
import orderBy from "lodash.orderby";

const MINT_COMPANY_ID = "2";
// const MINT_COMPANY_ID = "4";
const MINT_LOCATIONS = [
  {
    location_id: "3343",
    name: "MINT New Orleans",
  },
  {
    location_id: "3795",
    name: "MINT Hammond",
  },
  {
    location_id: "4035",
    name: "MINT Covington",
  },
];
// const MINT_LOCATIONS = [
//   {
//     location_id: "1590",
//     name: "MINT New Orleans",
//   },
//   {
//     location_id: "1881",
//     name: "MINT Hammond",
//   },
//   {
//     location_id: "3802",
//     name: "MINT Covington",
//   },
// ];

export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: Object,
    controls: Object,
    placeholder: {
      type: String,
      default: "Choose your insurance",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: "",
      isOpen: false,
    };
  },
  computed: {
    filteredOptions() {
      const options = orderBy(
        this.options || [],
        [(el) => el?.name?.toLowerCase()],
        ["asc"]
      );
      return options.filter((el) =>
        el?.name?.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    isClick() {
      return this.disabled ? null : "click";
    },
    isMint() {
      if (!this.$store.state.config?.companyId) return;
      return this.$store.state.config.companyId.toString() === MINT_COMPANY_ID;
    },
    isMintLocation() {
      if (!this.controls?.locations?.location_id) return;
      return (
        this.isMint &&
        MINT_LOCATIONS.some(
          (el) =>
            el.location_id === this.controls.locations.location_id.toString()
        )
      );
    },
    isMintLocationFontNormal() {
      return this.isMint && this.isMintLocation;
    },
    otherCarrierNote() {
      if (!this.value) return;
      if (this.value.id !== "other") return;
      if (!this.controls?.locations?.other_carrier_note) return;
      return this.controls.locations.other_carrier_note;
    },
    style() {
      return {
        "--dropdown-bg-color":
          this.$store.state.config?.colors?.containerBackground || "#FFFFFF",
        "--selected-bg-color":
          this.$store.state.config?.colors?.secondaryOptionColor || "#D4F3BB",
      };
    },
    // isFontNotNormal() {
    //   if (!this.controls?.locations) return;

    //   const companyId = this.$store.state.config?.companyId;
    //   const locationId = this.controls.locations?.location_id;

    //   return (
    //     ["2"].includes(companyId.toString()) &&
    //     MINT_LOCATIONS.some((el) => el.location_id === locationId.toString())
    //   );
    // },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;

      if (this.isOpen && this.filteredOptions.length > 3) {
        this.$nextTick(() => {
          this.$refs.search.focus();
        });
      }
    },
    open() {
      if (this.isOpen) {
        return;
      }
      this.isOpen = true;

      if (this.filteredOptions.length > 3) {
        this.$nextTick(() => {
          this.$refs.search.focus();
        });
      }
    },
    close() {
      if (!this.isOpen) {
        return;
      }
      this.isOpen = false;
    },
    select(option) {
      this.$emit("input", option);
      this.search = "";
      this.close();
    },
  },
};
</script>

<style scoped>
.max-h-dropdown {
  max-height: 250px;
}
.opacity-75 {
  opacity: 0.75;
}
.dropdown-bg-color {
  background-color: var(--dropdown-bg-color);
}
.selected-item {
  background-color: var(--selected-bg-color);
}
.hover\:selected-item:hover {
  background-color: var(--selected-bg-color);
}
button {
  background-image: url("data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Cpath d='M2.454 5.303L.636 7.121 7 13.485l6.364-6.364-1.818-1.818L7 9.849 2.454 5.303z' fill='%23191919'/%3E%3C/svg%3E");
  background-size: 14px;
  background-position-y: center;
  background-position-x: calc(100% - 6px);
}
</style>
